import { reactive } from "vue";
import axios from "axios";
import { useQuery } from "@tanstack/vue-query";

// URL API
const API_URL = "/Statistics/GetDashboardStatistics";

// state مشترک
export const dashboardState = reactive({
  dashboardQuery: null,
});

// init برای Option API
export function initDashboardState() {
  // Query برای دریافت کاربران
  dashboardState.dashboardQuery = useQuery(
    ["dashboard"],
    async () => {
      const { data } = await axios.get(API_URL);
     
      return data.value;
    },
    {
      staleTime: 1000 * 60 * 5, // ✅ کش معتبر تا ۵ دقیقه
      cacheTime: 1000 * 60 * 10, // نگهداری کش تا ۱۰ دقیقه
      refetchOnWindowFocus: false, // وقتی به تب برمی‌گردیم دوباره fetch نکن
    }
  );
}
